import { Routes, RouterModule  } from '@angular/router';
import { NgModule } from '@angular/core';

import { DashboardComponent } from '../../dashboard/dashboard.component';
import { UserProfileComponent } from '../../user-profile/user-profile.component';
import { TableListComponent } from '../../table-list/table-list.component';
import { TypographyComponent } from '../../typography/typography.component';
import { IconsComponent } from '../../icons/icons.component';
import { NotificationsComponent } from '../../notifications/notifications.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';
import { LoginComponent } from '../../auth/login/login.component';
import {MealsComponent} from '../../meals/meals.component';
import {AddMealComponent} from '../../meals/add-meal/add-meal.component';
import { MealDetailComponent } from '../../meals/meal-detail/meal-detail.component';
import { AddonsComponent } from '../../meals/meal-detail/addons/addons.component';
import { ScalesComponent } from '../../meals/meal-detail/scales/scales.component';
import { IngredientComponent } from '../../meals/meal-detail/ingredient/ingredient.component';
import {MenuComponent} from '../../meals/menu/menu.component';
import {AddMenuComponent} from '../../meals/menu/add-menu/add-menu.component';
import { UpdateMenuComponent } from '../../meals/menu/update-menu/update-menu.component';
import { UpdateMealComponent } from '../../meals/update-meal/update-meal.component';
import { AddNewMealComponent } from '../../meals/add-new-meal/add-new-meal.component';
import { UpdateIngrediantComponent } from '../../meals/update-ingrediant/update-ingrediant.component';
import { UpdateAddonComponent } from '../../meals/update-addon/update-addon.component';
import { UpdateScaleComponent } from '../../meals/update-scale/update-scale.component';
import { RestaurantTypeComponent } from '../../restaurant-type/restaurant-type/restaurant-type.component';
import { AddRestaurantTypeComponent } from '../../restaurant-type/add-restaurant-type/add-restaurant-type.component';
import { UpdateRestaurantTypeComponent } from '../../restaurant-type/update-restaurant-type/update-restaurant-type.component';
import { ScaleUnitComponent } from '../../meals/meal-detail/scale-unit/scale-unit.component';
import { IngredientTypeComponent } from '../../meals/meal-detail/ingredient-type/ingredient-type.component';
import { CategoryComponent } from '../../category/category/category.component';
import { AddCategoryComponent } from '../../category/add-category/add-category.component';
import { UpdateCategoryComponent } from '../../category/update-category/update-category.component';
// import { DispatucherRestaurantComponent } from 'src/app/restaurant/dispatucher-restaurant/dispatucher-restaurant.component';
// tslint:disable-next-line: max-line-length
import { UpdateIngredientTypeComponent } from '../../meals/meal-detail/ingredient-type/update-ingredient-type/update-ingredient-type.component';
import { UpdateScaleUnitComponent } from '../../meals/meal-detail/scale-unit/update-scale-unit/update-scale-unit.component';
import { ChatComponent } from '../../chat/chat.component';



export const AdminLayoutRoutes: Routes = [

    { path: 'login',          component: LoginComponent },
    { path: 'dashboard',      component: DashboardComponent },
    { path: 'chat', component: ChatComponent },
    { path: 'user-profile',   component: UserProfileComponent },
    { path: 'table-list',     component: TableListComponent },
    { path: 'typography',     component: TypographyComponent },
    { path: 'icons',          component: IconsComponent },
    { path: 'notifications',  component: NotificationsComponent },
    { path: 'upgrade',        component: UpgradeComponent },
    {
      path: 'restaurant',
      loadChildren: () => import('../../restaurant/restaurant.module').then(m => m.RestaurantModule)
    },
    {
      path: 'map',
      loadChildren: () => import('../../map/map.module').then(m => m.MapModule)
    },
    {
      path: 'orders',
      loadChildren: () => import('../../order/order.module').then(m => m.OrderModule)
    },
    {
      path: 'meals/:restId/:menuId', component: MealsComponent, children: [
        // { path: 'newMeal', component: AddMealComponent}
      ]
    },
   { path: 'Meal/:id', component: AddMealComponent},
   { path: 'newMeal/:restId/:menuId', component: AddNewMealComponent},
   { path: 'menu/:id', component: MenuComponent},
   { path: 'newMenu/:id', component: AddMenuComponent},
   {path: 'updateMenu/:restId/:menuId', component: UpdateMenuComponent},
   {path: 'updateMeal/:restId/:menuId/:id', component: UpdateMealComponent},
   {path: 'mealDetail/:restId/:menuId/:id', component: MealDetailComponent},
   { path: 'mealDetail/scale/:restId/:menuId/:mealId/:id', component: ScaleUnitComponent},
   { path: 'mealDetail/updateScale/:restId/:menuId/:mealId/:id/:cid', component: UpdateScaleUnitComponent},

   { path: 'mealDetail/ingrediant/:restId/:menuId/:mealId/:id', component: IngredientTypeComponent},
   { path: 'mealDetail/updateIngrediant/:restId/:menuId/:mealId/:id/:cid', component: UpdateIngredientTypeComponent},

  //  {path: 'updateIngrediant/:restId/:menuId/:Id/:id', component: UpdateIngredientTypeComponent},
   {path: 'updateAddon/:restId/:menuId/:Id/:id', component: UpdateAddonComponent},
   {path: 'updateScale/:restId/:menuId/:Id/:id', component: UpdateScaleComponent},
   { path: 'restaurantType', component: RestaurantTypeComponent},
   { path: 'addRestaurantType', component: AddRestaurantTypeComponent},
   { path: 'updateRestaurantType/:id', component: UpdateRestaurantTypeComponent},
   { path: 'mealCategory', component: CategoryComponent},
   { path: 'addMealCategory', component: AddCategoryComponent},
   { path: 'updateMealCategory/:id', component: UpdateCategoryComponent},
    {
      path: 'country',
      loadChildren: () => import('../../country-city/country-city.module').then(m => m.CountryCityModule)
    },
    {
      path: 'drivers',
      loadChildren: () => import('../../driver/driver.module').then(m => m.DriverModule)
    },
    {
      path: 'customers',
      loadChildren: () => import('../../customer/customer.module').then(m => m.CustomerModule)
    },
    {
      path: 'tags',
      loadChildren: () => import('../../tag/tag.module').then(m => m.TagModule)
    },
    {
      path: 'shifts',
      loadChildren: () => import('../../driver-shift/shift.module').then(m => m.ShiftModule)
    }

];
/*
@NgModule({
  imports: [RouterModule.forRoot(AdminLayoutRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
*/
